<template lang="pug">
  main
    NavBarUsuarios
    Loader(v-show="isLoading")
    section.hero(v-show="!isLoading")
      .container
        .columns.has-text-centered
          .column.is-12
            h3.title Permisos&nbsp
              |
              a.button.is-dark.is-rounded.is-medium(@click='backPage')
                i.fas.fa-times
        .columns
          .column
            FormPermisos(:permisos="permisos")
        .columns.column-blanco
</template>

<script>
  import NavBarUsuarios from '@/components/usuarios_Componentes/layout/NavBarUsuarios.vue'
  import FormPermisos from './componentes/FormPermisos.vue'
  import Loader from '@/components/shared/Loader.vue'
  import usuariosServices from '../../services/usuarios/usuarios'
  export default {
    name: 'Permisos Nuevo',
    components: { NavBarUsuarios, Loader, FormPermisos },
    data() {
      return {
        isLoading: true,
        usuarios: [],
        usuarioSel: {},
        permisos: []
      }
    },
    methods: {
      iniciarComponente() {
        this.obtenerUsuariosSinPermisos()
        this.obtenerPermisos()
      },
      obtenerUsuariosSinPermisos() {
        
      },
      obtenerPermisos () {
        usuariosServices.obtenerPermisos()
          .then( data => {
            const permisos_combustibles = data.permisos_combustibles.map(this.convetirPermisos)
            const permisos_inventarios = data.permisos_inventarios.map(this.convetirPermisos)
            const permisos_monitoreo = data.permisos_monitoreo.map(this.convetirPermisos)
            const permisos_reportes = data.permisos_reportes.map(this.convetirPermisos)
            const permisos_requisiciones = data.permisos_requisiciones.map(this.convetirPermisos)
            const permisos_responsivas = data.permisos_responsivas.map(this.convetirPermisos)
            const permisos_sca_irge = data.permisos_sca_irge.map(this.convetirPermisos)
            const permisos_sca_tpa = data.permisos_sca_tpa.map(this.convetirPermisos)
            const permisos_tags = data.permisos_tags.map(this.convetirPermisos)
            const permisos_tarjetas = data.permisos_tarjetas.map(this.convetirPermisos)
            const permisos_vehiculos = data.permisos_vehiculos.map(this.convetirPermisos)
            const permisos_facturas = data.permisos_facturas.map(this.convetirPermisos)
            const permisos_visitas = data.permisos_visitas.map(this.convetirPermisos)
            this.permisos = {
              permisos_combustibles,
              permisos_inventarios,
              permisos_monitoreo,
              permisos_reportes,
              permisos_requisiciones,
              permisos_responsivas,
              permisos_sca_irge,
              permisos_sca_tpa,
              permisos_tags,
              permisos_tarjetas,
              permisos_vehiculos,
              permisos_facturas,
              permisos_visitas,
            }
            this.isLoading = false
          })
          .catch( e => {
            this.isLoading = false
            this.displayToast('bubble',`Error: ${e.message}`,'ban', 'OK')
          })
      },

      convetirPermisos (permiso) {
        return {
          ...permiso,
          id: parseInt(permiso.id)
        }
      },

      backPage () {
        this.$router.back()
      },
    },
    created () {
      this.iniciarComponente()
    },
  }
</script>

<style lang="css" scoped>
.container {
    padding: 40px 0;
  }
  .column-blanco {
    padding-bottom: 120px;
  }
</style>


// WEBPACK FOOTER //
// src/components/usuarios_Componentes/PermisosNuevos.vue